import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

enum MessageType {
  Danger = "danger",
  Success = "success",
  Warn = "warn",
  Default = "default",
}

@Injectable({
  providedIn: "root",
})
export class SnackbarService {
  constructor(private snackBar: MatSnackBar) {}

  private duration = 3000;

  Open(message: string, action: string, type?: MessageType) {
    this.snackBar.open(message, action, {
      duration: this.duration,
      panelClass: [`style-${type || MessageType.Default}`],
      horizontalPosition: "center",
      verticalPosition: "top",
    });
  }

  Error(message: string, action: string = "OK") {
    this.Open(message, action, MessageType.Danger);
  }

  Warn(message: string, action: string = "OK") {
    this.Open(message, action, MessageType.Warn);
  }

  Success(message: string, action: string = "OK") {
    this.Open(message, action, MessageType.Success);
  }
}
